import axios from './axios';

const list = (limit = 1000, offset = 0, filter = {}, sorting = { fieldName: 'id', direction: 'asc' }) =>
  ({ limit, offset, filter, sorting });

// ---- Account / onboarding ----
export const signupClinic = (payload) => axios.post('/api/Account/Signup', payload);
export const lookupClinicByCode = (code) =>
  axios.get('/api/Account/ClinicByCode', { params: { code } });
export const requestToJoinClinic = (payload) => axios.post('/api/Account/JoinRequest', payload);

// ---- Current user / permissions ----
export const getMe = () => axios.get('/api/Me');

// ---- Roles & permissions ----
export const getRoles = () => axios.post('/api/Roles/List', list());
export const getPermissionCatalog = () => axios.get('/api/Roles/Permissions');
export const getRolePermissions = (roleId) => axios.get(`/api/Roles/${roleId}/Permissions`);
export const createRole = (name, permissionIds) => axios.post('/api/Roles/Create', { name, permissionIds });
export const setRolePermissions = (roleId, permissionIds) =>
  axios.post('/api/Roles/SetPermissions', { roleId, permissionIds });
export const deleteRole = (roleId) => axios.delete(`/api/Roles/${roleId}`);

// ---- Tenant users ----
export const getTenantUsers = () => axios.post('/api/TenantUsers/List', list());
export const inviteUser = (email, roleId) => axios.post('/api/TenantUsers/Invite', { email, roleId });
export const assignRole = (userId, roleId) => axios.post('/api/TenantUsers/AssignRole', { userId, roleId });
export const setUserActive = (userId, isActive) => axios.post('/api/TenantUsers/SetActive', { userId, isActive });

// ---- Join requests (admin approval queue) ----
export const getPendingMembers = () => axios.post('/api/TenantUsers/PendingList', {});
export const approveMember = (userId, roleId) => axios.post('/api/TenantUsers/Approve', { userId, roleId });
export const rejectMember = (userId, reason) => axios.post('/api/TenantUsers/Reject', { userId, reason });

// ---- Impersonation approvals (clinic admin) ----
export const getImpersonationRequests = () => axios.post('/api/TenantUsers/Impersonation/PendingList', {});
export const decideImpersonationRequest = (requestId, approve) =>
  axios.post('/api/TenantUsers/Impersonation/Decide', { requestId, approve });

// ---- Clinic settings ----
export const getJoinCode = () => axios.get('/api/Clinic/JoinCode');
export const rotateJoinCode = () => axios.post('/api/Clinic/RotateJoinCode');
export const getAssessorName = () => axios.get('/api/Clinic/AssessorName');
export const setAssessorName = (payload) => axios.put('/api/Clinic/AssessorName', payload);

// ---- Assessments (per-assessment payment) ----
export const startAssessment = (patientId) => axios.post('/api/Assessments/Start', { patientId });
export const confirmAssessmentPayment = (assessmentId, razorpayPaymentId, razorpaySignature) =>
  axios.post('/api/Assessments/ConfirmPayment', { assessmentId, razorpayPaymentId, razorpaySignature });
export const finishAssessment = (assessmentId) => axios.post('/api/Assessments/Finish', { assessmentId });
export const getActiveAssessment = (patientId) => axios.get('/api/Assessments/Active', { params: { patientId } });
export const getAssessmentReceipt = (assessmentId) => axios.get(`/api/Assessments/${assessmentId}/Receipt`);

// ---- Platform (super-admin) ----
export const getTenants = () => axios.post('/api/platform/Tenants/List', list());
export const setTenantStatus = (tenantId, status) =>
  axios.post('/api/platform/Tenants/SetStatus', { tenantId, status });
export const setTenantAssessmentPrice = (tenantId, price, currency = 'INR') =>
  axios.post('/api/platform/Tenants/SetAssessmentPrice', { tenantId, price, currency });
export const impersonateTenant = (tenantId) => axios.post('/api/platform/Impersonate', { tenantId });
export const requestImpersonation = (tenantId, reason) =>
  axios.post('/api/platform/Impersonate/Request', { tenantId, reason });
export const getMyImpersonationRequests = () => axios.get('/api/platform/Impersonate/Requests');
export const getPlatformOverview = () => axios.get('/api/platform/Overview');
export const getTenantDetail = (tenantId) => axios.get(`/api/platform/Tenants/${tenantId}`);
export const getPlatformUsers = (search = '', limit = 50, offset = 0) =>
  axios.post('/api/platform/Users/List', { search, limit, offset });
export const setPlatformAdmin = (userId, isPlatformAdmin) =>
  axios.post('/api/platform/Users/SetPlatformAdmin', { userId, isPlatformAdmin });
export const getAuditLog = (filters = {}) =>
  axios.post('/api/platform/AuditLog/List', { limit: 200, offset: 0, ...filters });
